import UserAvatar from '@/components/ui/user-avatar';
import { getInitials, getRandomColor } from '@/helpers/functions';
import { mapGetters } from 'vuex';

export default {
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    },
    participants: {
      type    : Array,
      default : () => ([])
    },
    academicMainTypeId: {
      type    : Number,
      default : null
    },
    academicMainId: {
      type    : Number,
      default : null
    }
  },
  components: {
    UserAvatar
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapGetters({
      getterMenuContext: 'plataforma/content/getterMenuContext'
    })
  },
  methods: {
    getRandomColor,
    getInitials,
    traitNewMessage(participant) {
      return {
        email          : participant.email,
        externalUserId : String(participant.safeaUserId),
        imagePath      : participant.profilePhoto,
        name           : participant.name,
        roleAlias      : participant.safeaAlias,
        safeaRole      : participant.safeaRole,
        contexts       : []
      };
    },
    sendMessageToAllStudents() {
      const data = {
        defaultBoxFilter : 'inbox',
        selectedContacts : [...this.participants.map(participant => this.traitNewMessage(participant))]
      };

      this.$nuxt.$emit('openMessageModal', data);
    },
    sendMessageToStudent(participant) {
      const data = {
        defaultBoxFilter : 'inbox',
        selectedContacts : [this.traitNewMessage(participant)]
      };

      this.$nuxt.$emit('openMessageModal', data);
    }
  }
};
